import { useState, useCallback } from "react";
import { CardOfTheDayStatus } from "../types/CardOfTheDayStatus";
import { AstroPrognosisStatus } from "../types/AstroPrognosisStatus";
import { ZodiacalPrognosisStatus } from "../types/ZodiacalPrognosisStatus";
import { LuckyCardStatus } from "../types/LuckyCardStatus";
import { HomeInfoDomain } from "@/types/HomeInfo";
import { formatTimeToNext } from "../utils/timeUtils";
import { contentUpdatingManager } from "@/api/contentUpdatingManager";

export const useStatusManagement = () => {
  const [cardOfTheDayStatus, setCardOfTheDayStatus] = useState<CardOfTheDayStatus | null>(null);
  const [astroPrognosisStatus, setAstroPrognosisStatus] = useState<AstroPrognosisStatus | null>(null);
  const [zodiacalPrognosisStatus, setZodiacalPrognosisStatus] = useState<ZodiacalPrognosisStatus | null>(null);
  const [luckyCardStatus, setLuckyCardStatus] = useState<LuckyCardStatus | null>(null);
  const [aboutText, setAboutText] = useState<string>("");

  const updateCardOfTheDayStatus = useCallback((homeInfo: HomeInfoDomain) => {
    const resetDateRaw = homeInfo?.cardOfTheDay?.resetDate;
    const card = homeInfo.cardOfTheDay;

    if (card === null) {
      setCardOfTheDayStatus({ isAvailable: true, timeToNextCard: "Доступно", card: null });
      return;
    }

    if (!resetDateRaw || isNaN(resetDateRaw.getTime())) {
      setCardOfTheDayStatus({ isAvailable: false, timeToNextCard: "Нет данных", card });
      return;
    }

    const diff = resetDateRaw.getTime() - new Date().getTime();
    const timeToNextCard = formatTimeToNext(diff, "Открытие через");
    
    setCardOfTheDayStatus({
      isAvailable: diff <= 0,
      timeToNextCard,
      card: card, // Всегда показываем карту, независимо от доступности
    });
  }, []);

  const updateAboutText = useCallback((aboutText: string) => {
    setAboutText(aboutText);
  }, []);

  

  const updateAstroPrognosisStatus = useCallback(() => {
    const lastUpdating = contentUpdatingManager.getAstroPrognosisDataLastUpdating();
    if (lastUpdating === null) {
      setAstroPrognosisStatus({ isAvailable: true, timeToNextCard: "Доступно" });
      return;
    }

    const diff = lastUpdating.getTime() - new Date().getTime();
    const timeToNextCard = formatTimeToNext(diff, "До следующего прогноза");
    
    setAstroPrognosisStatus({
      isAvailable: diff <= 0,
      timeToNextCard,
    });
  }, []);

  const updateZodiacalPrognosisStatus = useCallback((isSubscribed: boolean) => {

    if (!isSubscribed) {
      setZodiacalPrognosisStatus({ isAvailable: false, timeToNextCard: "", isSubscribed: false });
      return;
    }

    const lastUpdating = contentUpdatingManager.getZodiacPrognosisDataLastUpdating();

    if (lastUpdating === null) {
      console.log("updateZodiacalPrognosisStatus: true");
      setZodiacalPrognosisStatus({ isAvailable: true, timeToNextCard: "Доступно", isSubscribed: true });
      return;
    }
    console.log("updateZodiacalPrognosisStatus: ", lastUpdating);
    console.log("updateZodiacalPrognosisStatus: ", new Date());
    const diff = lastUpdating.getTime() - new Date().getTime();
    const timeToNextCard = formatTimeToNext(diff, "До следующего прогноза");

    setZodiacalPrognosisStatus({
      isAvailable: diff <= 0,
      timeToNextCard,
      isSubscribed: true,
    });
  }, []);

  const updateLuckyCardStatus = useCallback((homeInfo: HomeInfoDomain, isSubscribed: boolean) => {
    if (!isSubscribed) {
      setLuckyCardStatus({
        isAvailable: false,
        timeToNextCard: "",
        isSubscribed: false,
        selectedCard: null,
        luckyCard: null,
      });
      return;
    }

    const resetDateRaw = homeInfo?.luckyCardResetDate;
    const selectedCard = homeInfo.selectedLuckyCard;
    const luckyCard = homeInfo.luckyCard;

    if (resetDateRaw === null) {
      setLuckyCardStatus({
        isAvailable: true,
        timeToNextCard: "Доступно",
        selectedCard,
        luckyCard,
        isSubscribed: true,
      });
      return;
    }

    const diff = resetDateRaw.getTime() - new Date().getTime();
    const timeToNextCard = formatTimeToNext(diff, "До следующей карты");
    
    setLuckyCardStatus({
      isAvailable: diff <= 0,
      timeToNextCard,
      selectedCard,
      luckyCard,
      isSubscribed: true,
    });
  }, []);

  return {
    cardOfTheDayStatus,
    astroPrognosisStatus,
    zodiacalPrognosisStatus,
    luckyCardStatus,
    aboutText,
    updateCardOfTheDayStatus,
    updateAstroPrognosisStatus,
    updateZodiacalPrognosisStatus,
    updateLuckyCardStatus,
    updateAboutText,
  };
}; 